import React from 'react';
import { CalculatorSection } from './../Calculators/Sections';
import { TextInput, RangerInput } from './../Form/index';
import { ErrorBox } from './Sidebar';
import { toPct } from './../../services/Formats';

export const StopIcon = () => (
  <svg viewBox="0 0 512 512" style={{ width: 32, height: 32 }}>
    <path
      fill="#ff0000"
      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
    />
  </svg>
);

export const ClientLoan = ({ input, output, onChangeInput }) => (
  <CalculatorSection className="section-loan" icon='loan2019'>
    <div className="title">Client loan</div>
    <div className="section-row">
      <div className="pad">
        <div className="label">Client age</div>
        <TextInput
          width={150} style={{ textAlign: 'right' }}
          value={input.clientAge} onChange={val => { onChangeInput('clientAge', val) }} />
      </div>

    </div>
    {(input.clientAge < 55 || input.clientAge > 95) ? (
      <div className="section-row">
        <div style={{ marginLeft: 20, marginRight: 20, width: '100%' }}>
          <ErrorBox style={{ fontSize: 14, marginTop: 0 }}>
            Please enter client age between 55 and 95
          </ErrorBox>
        </div>
      </div>
    ): false}

    <div className="section-row">
      <div className="pad">
        <div className="label">Loan amount</div>
        <TextInput
          width={150} style={{ textAlign: 'right' }}
          type="currency" prefixes="&pound;"  value={input.loanTaken} onChange={val => { onChangeInput('loanTaken', parseFloat(val, 10)) }} />
        {/*(input.loanTaken > output.ltv.max) ? (<div style={{ paddingTop: 60 }}><StopIcon /></div>) : false*/}
      </div>
    </div>

    {(input.loanTaken > output.ltv.max) ? (
      <div className="section-row">
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <ErrorBox style={{ fontSize: 14, marginTop: 0 }}>
            The loan amount entered is higher than the amount your client could borrow with a more 2 life
            Maximum Choice lifetime mortgage, please enter an amount up to £{output.ltv.max}
          </ErrorBox>
        </div>
      </div>
    ): false}

    <div className="section-row">
      <div className="pad" style={{ paddingTop: 5 }}>
        <div className="label">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div>Loan MER (%) &nbsp; &nbsp; </div>
            <div style={{ width: 75 }}>
              <TextInput
                type='percent'
                width={75}
                style={{ textAlign: 'center' }}
                value={toPct(input.interestTaken)}
                onChange={val => {
                  if (val >= 2.25 && val <= 8) {
                    onChangeInput('interestTaken', val)
                  }
                }} />
            </div>
          </div>
        </div>
        <div>
          <RangerInput
            className="ranger"
            value={input.interestTaken} min={2.25} max={8} type='float' div={20}
            inactiveColor='#bbbbbb' withLabel={true}
            onChange={val => { onChangeInput('interestTaken', val) }}  />
        </div>
      </div>
    </div>
    <div className="section-row">
      <div className="pad" style={{ fontSize: '0.75em' }}>
        Loan APR varies from a minimum 2.25 to a maximum of 8%
      </div>
    </div>
  </CalculatorSection>
);



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/ClientLoan.js